import { db } from '../utils/firebase.js';
import { orderBy, doc, query, addDoc, setDoc, getDoc, updateDoc, collection, getDocs, where, limit, increment } from "firebase/firestore";
import { auth } from '../utils/firebase.js';
import { DefaultGameObject, DefaultPlayerObject } from '../objects/initial_database_structure.js';
import { todayMMDDYYYY } from '../utils/getToday.js';

export const _sendContactForm = async (includeEmail, message) => {
    let contactData = {
        'message': message,
        'sent': new Date(),
        'processed': false
    }

    if (includeEmail) {
        contactData.email = auth.currentUser.email;
    }

    const contactFormRef = collection(db, 'contactForms');
    await setDoc(doc(contactFormRef), contactData);
}